export default __webpack_public_path__ + "static/media/avatar_1@2x.11f87043.png";